import React, {Component} from 'react';
import {Card} from 'semantic-ui-react';
import UsageTable from './table';
import Charts from './charts';
import './LocationsReport.scss';

class LocationsReport extends Component {
  render() {
    return (
      <div className='warehouse-locations-usage'>
        <Card className='title-card' fluid raised >
          <h2>Reporte de Ubicaciones</h2>
          <UsageTable />
        </Card>
        <Charts />
      </div>
    );
  }
}

export default LocationsReport;
